// BCM leadership team.
//
// INTERNAL CONTENT NOTE (not rendered on the public site):
// Leader photographs are expected before the fall launch. Add each hosted image
// URL to `photo` and the role card swaps the initials placeholder for the real
// photo. Do not add biographies, majors, graduation years, social links, or
// quotes unless BCM supplies them.

export type BcmLeader = {
  id: string
  /** Only the name that was supplied — never invent last names. */
  name: string
  role: string
  /** Hosted URL of a real photo of this leader. Empty until supplied. */
  photo?: string
  /** Internal-only note. Never rendered in the UI. */
  devNote?: string
}

export const leadership: BcmLeader[] = [
  { id: 'brad-crawford', name: 'Brad Crawford', role: 'Director' },
  { id: 'gabriela', name: 'Gabriela', role: 'President' },
  { id: 'soren', name: 'Soren', role: 'Vice President' },
  { id: 'paul', name: 'Paul', role: 'Ministry Partner' },
  {
    id: 'rachel',
    name: 'Rachel',
    role: 'Media Director',
    // TODO: Confirm whether Media Director spelling is Rachel or Rachael before launch.
    devNote: 'Confirm whether Media Director spelling is Rachel or Rachael before launch.',
  },
  { id: 'jacob', name: 'Jacob', role: 'Co-Worship Lead' },
  { id: 'christian', name: 'Christian', role: 'Co-Worship Lead' },
  { id: 'bryce', name: 'Bryce', role: 'Tech Director' },
  { id: 'robert', name: 'Robert', role: 'Outreach Director' },
  { id: 'alfredo', name: 'Alfredo', role: 'Events Director' },
]
